<template>
  <div>

    <div class="contentView">
      <div class="is-flex is-justify-content-flex-start">
        <b-button @click="openSteps()" class="addPatientButton">
          <strong>Add Patient</strong>
        </b-button>
      </div>
      <!-- searchbar -->
      <b-input v-model="searchQuery" placeholder="Search..." type="search" icon="magnify" class="mb-3" rounded />
      <!-- list all patients -->
      <div v-for="(patient, patientIdx) in searchResults" :key="patientIdx">
        <div @click="selectPatient(patient)" class="backgroundBoi edit-item-btn is-clickable">
          <div class="is-flex">
            <h3 class="patientName">{{ patient.name }}</h3>
          </div>
          <div class="is-flex is-flex-direction-colummn is-align-items-space-between">
            <p>{{ patient.patientCode }}</p>
            <h3 class="recoveryType">
              {{ patient.recoveryType }}
            </h3>
          </div>
        </div>
      </div>
      <div v-if="patientList.length === 0">
        <p>No patients yet.</p>
      </div>
    </div>
    
    <!-- patient data modal (edit an existing plan, view progress) -->
    <b-modal v-model="showPatientData" :can-cancel="false" full-screen destroy-on-hide>
      <div v-if="showPatientData" class="modal-card">
        <header class="modal-card-head is-flex is-justify-content-center">
          <div class="contentView is-flex is-justify-content-space-between">
            <p class="title is-3 mb-0">{{ selectedPatient.name }}</p>
            <b-button @click="closeBuilder()" class="is-danger is-light" icon-right="close-thick" />
          </div>
        </header>
        <section class="modal-card-body">
          <div v-if="selectedPatient">
            <builder :isViewingProgress="true" />
          </div>
          <div v-else>
            No progress yet.
          </div>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-center">
          <div class="contentView buttons is-flex is-justify-content-flex-end">
            <b-button @click="deletePatient()" icon-right="delete" class="is-danger">
              <strong>Delete Patient</strong>
            </b-button>
          </div>
        </footer>
      </div>
    </b-modal>

    <!-- add a new member, select an existing plan, then customize plan -->
    <b-modal v-model="showAddMember" :can-cancel="false" full-screen destroy-on-hide>
      <div class="modal-card">
        <header class="modal-card-head is-flex is-justify-content-center columns">
          <div class="column is-1" />
          <div class="column">
            <b-steps v-model="activeStep" type="is-info" :mobile-mode="null" :has-navigation="false">
              <b-step-item icon="account-key">
                <p class="title is-3 mt-2">Patient</p>
              </b-step-item>
              <b-step-item icon="account">
                <p class="title is-3 mt-2">Template</p>
              </b-step-item>
              <b-step-item icon="account-plus">
                <p class="title is-3 mt-2">Customize</p>
              </b-step-item>
            </b-steps>
          </div>
          <div class="column is-1">
            <b-button @click="showAddMember = false;" class="is-danger is-light" icon-right="close-thick" />
          </div>
        </header>
        <section class="modal-card-body is-flex is-flex-direction-column is-align-items-center" :class="{ 'is-justify-content-center': activeStep==0 }">
          <div class="contentView">
            <div v-if="activeStep==0" class="width-100 is-flex is-justify-content-center is-align-items-center">
              <form class="addPatientForm">
                <b-input v-model="$root.firstName" placeholder="First Name" />
                <b-input v-model="$root.lastName" placeholder="Last Name" />
                <b-input v-model="$root.email" placeholder="Email Address" />
                <b-button @click="nextView(true)" :disabled="!canClickNext" class="is-info"> <!-- :disabled="!canClickNext" -->
                  <strong>Next</strong>
                </b-button>
              </form>
            </div>
            <div v-if="activeStep==1">
              <templateTabs
                :showEditor="false"
                @selectedTemplate="nextView(true)"
              />
            </div>
            <div v-if="activeStep==2">
              <builder />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="nextView(false)" class="is-info is-light" icon-right="keyboard-return" :disabled="activeStep === 0">
            <strong>Back</strong>
          </b-button>
        </footer>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { db, references } from "@/main";
import { mapState } from "vuex";
import builder from "@/views/Builder.vue";
import templateTabs from "@/components/templateTabs.vue";

export default {
  name: "Patients",
  computed: {
    searchablePatients () {
      return this.patientList.map(patient => {
        let object = patient;
        object.name = `${patient.firstName} ${patient.lastName}`;
        return object;
      })
    },
    searchResults() {
      return this.searchablePatients.filter(option => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) >= 0;
      })
    },
    canClickNext() {
      if (this.$root.firstName && this.$root.lastName && this.$root.email) {
        return true;
      } return false;
    },
    ...mapState({
      user: state => state.auth.user,
      patientList: state => state.patientsList,
      hasBeenEdited: state => state.hasPlanEdited,
    })
  },
  components: {
    templateTabs,
    builder,
  },
  mounted () {
    this.$root.$on('closeAddPatient', this.close) // adding a new patient
    this.$root.$on('closeShowPatientData', this.close) // when updating an existing patient's data
  },
  beforeDestroy() {
    this.$store.commit('SET_BUILDER_BAR_TYPE', null)
  },
  data() {
    return {
      showAddMember: false,
      activeStep: 0,
      showPatientData: false,
      selectedPatient: {},
      searchQuery: '',
      selected: null,
    };
  },

  methods: {
    deletePatient() {
      console.log(this.selectedPatient.id)
      this.$buefy.dialog.confirm({
        title: `Delete Patient`,
        message: `Deleting <b>${this.selectedPatient.firstName} ${this.selectedPatient.lastName}</b> is permanant and cannot be undone. Continue?`,
        type: 'is-danger',
        onConfirm: () => {
          db.collection(references.practice).doc(this.user.practice.id).collection('patients').doc(this.selectedPatient.id).delete()
            .then(() => {
              this.showPatientData = false;
              this.selectedPatient = null;
              this.$buefy.toast.open({
                position: 'is-top',
                message: 'Patient Deleted!'
              })
            })
            .catch(() => {
              this.$buefy.toast.open({
                position: 'is-top',
                message: 'Could not delete patient! Try again.',
                type: 'is-danger'
              })
            })
        }
      })
    },
    close(type) { // handles close events from $root, triggered by builder_Menu_Bar.vue
      if (type == 'add') {
        this.showAddMember = false;
      } else if (type == 'update') {
        this.showPatientData = false;
      }
    },
    closeBuilder() {
      if (!this.hasBeenEdited) {
        this.showPatientData = false;
        return;
      }
      this.$buefy.dialog.confirm({
        title: 'Exit Builder',
        message: 'If you exit now, all progress will be lost.',
        type: 'is-danger',
        onConfirm: () => {
          this.showPatientData = false;
        }
      })
    },
    nextView(value) {
      this.$store.commit('SET_BUILDER_BAR_TYPE', 'newCustomer') // TODO: manually reseting at navigation is hacky
      if (value) {
        this.activeStep++;
        return;
      } else {
        this.activeStep--;
      }
    },
    openSteps() {
      this.$store.commit('SET_BUILDER_BAR_TYPE', 'newCustomer')
      this.activeStep = 0;
      this.$root.firstName = null; this.$root.lastName = null; this.$root.email = null;
      this.showAddMember = true;
    },
    async selectPatient(patient) {
      this.$root.selectedPatientID = patient.patientCode;
      this.selectedPatient = patient;
      this.$store.commit('SET_LOADING_STATE', true)
      await db.collection('patientProgress').doc(patient.patientCode).collection('progress').doc('plan').get()
        .then(snap => {
          // console.log(querySnapshot.data())
          this.$store.commit('SELECT_TEMPLATE', snap.data()); // the selected template is the exact data from that patient's 'progress/plan' doc
          this.$store.commit('SET_BUILDER_BAR_TYPE', 'updateCustomer');
          this.showPatientData = true;
        })
        .catch(() => {
          // this.$store.commit('SET_LOADING_STATE', false)
          this.$buefy.dialog.alert({
            title: 'Error',
            message: `There was an error fetching ${patient.firstName} ${patient.lastName}'s data. Please check your internet connection, refresh the page, and try again`,
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        })
      this.$store.commit('SET_LOADING_STATE', false)
    },
  },
};
</script>


<style lang="scss" scoped>

.addPatientForm {
  width: 400px;
  * {
    margin-bottom: .5rem;
  }
}

ul.step-items {
  list-style: none !important;
}

.backgroundBoi {
  background-color: white;
  border-radius: 15px;
  padding-left: 20px;
  padding-top: 8px;
  padding-bottom: 5px;
  margin-bottom: 12px;
  box-shadow: 2px 2px 6px #c0c0c0;
  transition: box-shadow .3s ease-in-out;
}

.backgroundBoi:hover {
  box-shadow: 4px 4px 8px #c0c0c0;
}

.recoveryType {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  color: #222222;
  font-weight: 400;
  font-size: 18px;
  margin-top: 0px;
  margin-bottom: 5px;
  width: 100%;
  padding-right: 20px;
  text-align: right;
}

.patientName {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  padding-right: 10px;
  font-weight: 400;
  font-size: 35px;
  margin-bottom: 0px;
  margin-top: 0pc;
  color: #222222;
}

.addPatientButton {
  background-color: #18a0fb;
  color: #ffffff;
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 18px;
  border-radius: 100px;
}
</style>